import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import ExternalAlerts from "../Company_profile/EWS";
import Document from "../Company_profile/Document";
import RiskCompany from "../Company_profile/RIskCompany";
import AppAppBar from "../homePage/AppAppBar";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


const SearchPage = () => {
  const { newValue } = useParams();
  const navigate = useNavigate();

  const handlePricing = () => {
    navigate(`/pricing`);
  };
  const [showScroll, setShowScroll] = useState(false);

  // Function to handle scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Function to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };
    

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const sections = [
    {
      title: "Early Warning Alerts",
      component: <ExternalAlerts />,
    },
    {
      title: "Risk Alerts",
      component: <RiskCompany />,
    },
    {
      title: "Document",
      component: <Document />,
    },
  ];

  const [activeSection, setActiveSection] = useState(0);

  const handleSectionClick = (index) => {
    setActiveSection(index);
  };
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <Container maxWidth="lg" sx={{ my: { xs: 10, md: 13 } }}>
      <AppAppBar showSubMenu={false} showPricing={true}  showTermsofService={true} showContactUs={true}  />
    

      <Typography variant="h4" gutterBottom>
        Search Results for: {newValue}
      </Typography>
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        {sections.map((section, index) => (
          <Button
            key={index}
            variant="contained"
            onClick={() => handleSectionClick(index)}
            sx={{ minWidth: 180 }}
          >
            {section.title}
          </Button>
        ))}
      </Box>
      <Box sx={{ mt: 3 }}>
        {sections[activeSection] && (
          <>
            <Typography variant="h5" gutterBottom>
              {sections[activeSection].title}
            </Typography>
            <Divider />
            {sections[activeSection].component}
          </>
        )}
      </Box>
      <Button
        variant="contained"
        onClick={handlePricing}
        color="primary"
        sx={{ mt: 2 }}
      >
        Check Prices
      </Button>
      {/* Scroll to Top Button */}
      {showScroll && (
        <Button
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            bgcolor: "primary.light",
            color: "white",
            borderRadius: "50%",
            minWidth: 40,
            minHeight: 40,
            padding: 0,
            display: "flex", // Use flexbox
            justifyContent: "center", // Horizontally center the icon
            alignItems: "center", // Vertically center the icon
            "&:hover": {
              bgcolor: "primary.dark",
            },
          }}
          variant="contained"
        >
          <KeyboardArrowUpIcon />
        </Button>
      )}
    </Container>
  );
};

export default SearchPage;
